/**
 * Shop Pay installments banner — whole card opens the native plans modal.
 * Hides when the widget has nothing to show (below Shop Pay min price).
 */
(function () {
  function openModal(card) {
    var terms = card.querySelector('shopify-payment-terms');
    var trigger =
      terms &&
      terms.shadowRoot &&
      terms.shadowRoot.querySelector('button,[role="button"],a');
    if (trigger) trigger.click();
  }

  function hideInfoIcon(terms, state) {
    var sr = terms.shadowRoot;
    if (!sr) return;

    var btn = sr.querySelector('button[aria-label="View sample plans"]');
    if (!btn) {
      sr.querySelectorAll('button').forEach(function (candidate) {
        if (!btn && !candidate.textContent.trim() && candidate.querySelector('svg')) {
          btn = candidate;
        }
      });
    }
    if (btn) btn.style.setProperty('display', 'none', 'important');

    if (!state.infoObserved) {
      state.infoObserved = true;
      new MutationObserver(function () {
        hideInfoIcon(terms, state);
      }).observe(sr, { childList: true, subtree: true });
    }
  }

  function bindCard(card) {
    if (card.dataset.installmentsBound) return;
    card.dataset.installmentsBound = '1';

    var state = { infoObserved: false, tries: 0 };
    var terms = card.querySelector('shopify-payment-terms');

    card.addEventListener('click', function (event) {
      if (event.target.closest('shopify-payment-terms')) return;
      openModal(card);
    });

    card.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openModal(card);
      }
    });

    if (!terms) {
      card.classList.add('product-installments--empty');
      return;
    }

    function checkEmpty() {
      hideInfoIcon(terms, state);

      var wasHidden = card.classList.contains('product-installments--empty');
      if (wasHidden) {
        card.style.visibility = 'hidden';
        card.classList.remove('product-installments--empty');
      }

      var height = terms.getBoundingClientRect().height;
      var trigger =
        terms.shadowRoot &&
        terms.shadowRoot.querySelector('button,[role="button"],a');
      var empty = height < 4 && !trigger;

      card.classList.toggle('product-installments--empty', empty);
      card.style.visibility = '';

      if (empty && state.tries < 20) {
        state.tries += 1;
        setTimeout(checkEmpty, 500);
      }
    }

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('shopify-payment-terms').then(function () {
        setTimeout(checkEmpty, 50);
      });
    } else {
      setTimeout(checkEmpty, 300);
    }
  }

  function init() {
    document.querySelectorAll('.product-installments').forEach(bindCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
